import { Check } from "lucide-react";
import { waarom, galerij } from "../../data/content";

export const Waarom = () => {
  return (
    <section id="over" data-testid="waarom-section" className="py-16 md:py-24 bg-accent/40">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <span className="text-primary font-semibold text-sm uppercase tracking-wide">Over De Proatkoele</span>
            <h2 className="font-heading text-3xl md:text-4xl font-semibold tracking-tight mt-3">
              Waarom De Proatkoele?
            </h2>
            <p className="mt-4 text-lg text-muted-foreground leading-relaxed">
              We zijn een lokaal partycenter met aandacht voor mensen. Geen poespas, wel een warm welkom.
            </p>
            <ul className="mt-8 space-y-4">
              {waarom.map((w, i) => (
                <li key={i} data-testid={`waarom-${i}`} className="flex gap-4">
                  <span className="mt-0.5 shrink-0 w-7 h-7 rounded-full bg-primary flex items-center justify-center">
                    <Check size={16} className="text-primary-foreground" />
                  </span>
                  <div>
                    <h3 className="font-heading text-lg font-semibold leading-tight">{w.titel}</h3>
                    <p className="text-muted-foreground">{w.tekst}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <img src={galerij[1].url} alt={galerij[1].alt} className="rounded-2xl object-cover h-full w-full row-span-2" />
            <img src={galerij[7].url} alt={galerij[7].alt} className="rounded-2xl object-cover h-44 w-full" />
            <img src={galerij[6].url} alt={galerij[6].alt} className="rounded-2xl object-cover h-44 w-full" />
          </div>
        </div>
      </div>
    </section>
  );
};
